import React from 'react';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import CreditLineStatus from '../Common/CreditLineStatus';

const Credit = () => {
  const getAvailableTabs = () => {
    return [
      {
        label: 'Línea de Crédito',
        component: <CreditLineStatus productId="credit" />,
        index: 0,
      },
    ];
  };

  const tabs = getAvailableTabs();

  return (
    <div>
      <EnhancedTab title="Crédito" startValue={0} tabs={tabs} />
    </div>
  );
};

export default Credit;
